import React, { useState, useEffect } from 'react'
import ReactECharts from 'echarts-for-react'
import { Col, Row } from 'rsuite'
import * as echarts from 'echarts'

export default function OverallNodeProvinceChart({
  compStyle = { height: '400px', width: '100%' },
  seriesData = [],
  onClickCheart = () => {},
  ...props
}) {
  const [chartOption, setChartOption] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const initMap = async () => {
      setLoading(true)
      await loadMap()
      setLoading(false)
    }

    initMap()
  }, [])

  const loadMap = async () => {
    try {
      const response = await import('./thailand.json')
      const thailandJson = response.default

      // console.log('thailand map data => ', response.default)

      // register แผนที่ประเทศไทย
      echarts.registerMap('thailand', thailandJson)

      setChartOption({
        tooltip: {
          trigger: 'item',
          showDelay: 0,
          transitionDuration: 0.2,
        },
        visualMap: {
          show: false,
          left: 'right',
          min: 500000,
          max: 10000000,
          inRange: {
            color: [
              '#313695',
              '#4575b4',
              '#74add1',
              '#abd9e9',
              '#e0f3f8',
              '#ffffbf',
              '#fee090',
              '#fdae61',
              '#f46d43',
              '#d73027',
              '#a50026',
            ],
          },
        },
        series: [
          {
            name: 'Thailand',
            type: 'map',
            roam: true,
            map: 'thailand',
            emphasis: { label: { show: true } },
            data: seriesData,
            // data: [
            //   {
            //     value: 1200,
            //     itemStyle: { color: '#ff6b6b' },
            //     name: 'กรุงเทพมหานคร',
            //     id: '1234jjkkk',
            //   },
            //   { value: 800, itemStyle: { color: '#4ecdc4' }, name: 'เชียงใหม่', id: '1111' },
            //   { value: 600, itemStyle: { color: '#45b7d1' }, name: 'ขอนแก่น', id: '2222' },
            //   { value: 500, itemStyle: { color: '#96ceb4' }, name: 'สงขลา', id: '3333' },
            //   { value: 750, itemStyle: { color: '#feca57' }, name: 'นครราชสีมา', id: '4444' },

            //   // ลบข้อมูลที่ซ้ำออกและจัดเรียงใหม่
            //   { name: 'กรุงเทพมหานคร', value: 5588000 },
            //   { name: 'พระนครศรีอยุธยา', value: 1 },
            //   { name: 'กระบี่', value: 467000 },
            //   { name: 'กาญจนบุรี', value: 887000 },
            //   { name: 'กาฬสินธุ์', value: 998000 },
            //   { name: 'กำแพงเพชร', value: 745000 },
            //   { name: 'ขอนแก่น', value: 1796000 },
            //   { name: 'จันทบุรี', value: 527000 },
            //   { name: 'ฉะเชิงเทรา', value: 709000 },
            //   { name: 'ชลบุรี', value: 1488000 },
            //   { name: 'ชัยนาท', value: 333000 },
            //   { name: 'ชัยภูมิ', value: 1141000 },
            //   { name: 'ชุมพร', value: 507000 },
            //   { name: 'เชียงราย', value: 1297000, id: '1234jjkkk' },
            //   { name: 'เชียงใหม่', value: 1756000, id: '88999' },
            //   { name: 'ตรัง', value: 640000 },
            //   { name: 'ตราด', value: 229000 },
            //   { name: 'ตาก', value: 543000 },
            //   { name: 'นครนายก', value: 257000 },
            //   { name: 'นครปฐม', value: 950000 },
            //   { name: 'นครพนม', value: 715000 },
            //   { name: 'นครราชสีมา', value: 2634000 },
            //   { name: 'นครศรีธรรมราช', value: 1556000 },
            //   { name: 'นครสวรรค์', value: 1077000 },
            //   { name: 'นนทบุรี', value: 1272000 },
            //   { name: 'นราธิวาส', value: 785000 },
            //   { name: 'น่าน', value: 481000 },
            //   { name: 'บึงกาฬ', value: 421000 },
            //   { name: 'บุรีรัมย์', value: 1579000 },
            //   { name: 'ปทุมธานี', value: 1169000 },
            //   { name: 'ประจวบคีรีขันธ์', value: 537000 },
            //   { name: 'ปราจีนบุรี', value: 486000 },
            //   { name: 'ปัตตานี', value: 706000 },
            //   { name: 'พะเยา', value: 495000 },
            //   { name: 'พังงา', value: 267000 },
            //   { name: 'พัทลุง', value: 520000 },
            //   { name: 'พิจิตร', value: 549000 },
            //   { name: 'เพชรบุรี', value: 482000 },
            //   { name: 'เพชรบูรณ์', value: 994000 },
            //   { name: 'แพร่', value: 466000 },
            //   { name: 'ภูเก็ต', value: 417000 },
            //   { name: 'มหาสารคาม', value: 965000 },
            //   { name: 'มุกดาหาร', value: 354000 },
            //   { name: 'แม่ฮ่องสอน', value: 256000 },
            //   { name: 'ยโสธร', value: 544000 },
            //   { name: 'ยะลา', value: 532000 },
            //   { name: 'ร้อยเอ็ด', value: 1318000 },
            //   { name: 'ระนอง', value: 182000 },
            //   { name: 'ระยอง', value: 688000 },
            //   { name: 'ราชบุรี', value: 859000 },
            //   { name: 'ลพบุรี', value: 758000 },
            //   { name: 'ลำปาง', value: 755000 },
            //   { name: 'ลำพูน', value: 408000 },
            //   { name: 'เลย', value: 636000 },
            //   { name: 'ศรีสะเกษ', value: 1462000 },
            //   { name: 'สกลนคร', value: 1150000 },
            //   { name: 'สงขลา', value: 1421000 },
            //   { name: 'สตูล', value: 318000 },
            //   { name: 'สมุทรปราการ', value: 1378000 },
            //   { name: 'สมุทรสงคราม', value: 195000 },
            //   { name: 'สมุทรสาคร', value: 557000 },
            //   { name: 'สระแก้ว', value: 553000 },
            //   { name: 'สระบุรี', value: 632000 },
            //   { name: 'สิงห์บุรี', value: 214000 },
            //   { name: 'สุโขทัย', value: 611000 },
            //   { name: 'สุพรรณบุรี', value: 863000 },
            //   { name: 'สุราษฎร์ธานี', value: 1040000 },
            //   { name: 'สุรินทร์', value: 1393000 },
            //   { name: 'หนองคาย', value: 520000 },
            //   { name: 'หนองบัวลำภู', value: 508000 },
            //   { name: 'อ่างทอง', value: 284000 },
            //   { name: 'อำนาจเจริญ', value: 383000 },
            //   { name: 'อุดรธานี', value: 1568000 },
            //   { name: 'อุตรดิตถ์', value: 460000 },
            //   { name: 'อุทัยธานี', value: 335000 },
            //   { name: 'อุบลราชธานี', value: 1882000 },
            // ],
          },
        ],
      })
    } catch (error) {
      console.error('Error loading Thailand map:', error)
    }
  }

  const onEvents = {
    click: (params) => {
      // console.log('คลิกที่:', params)

      onClickCheart(params.data)
    },
    // mouseover: (params) => {
    //   console.log('Hover:', params.name)
    // },
  }

  if (!chartOption) {
    return <div>กำลังโหลดแผนที่...</div>
  }

  return (
    <div>
      <ReactECharts option={chartOption} style={compStyle} onEvents={onEvents} />
    </div>
  )
}
